import React, { PropsWithChildren, useState } from 'react';
import { canViewSeries } from '@yi/core/src/user-access';

import { Episode } from '~/src/common/lean-back';
import { useAccessTier } from '~/src/common/subscription';

import { Modal } from './Modal';
import { SeriesPaywall } from './SeriesPaywall';

interface Props {
  episode: Episode;
  episodeUrl: string;
}
export const PlayButtonModal: React.FC<PropsWithChildren<Props>> = ({
  episode,
  children,
  episodeUrl,
}) => {
  const episodeId = episode.id();
  const mediaId = episode.mediaId();
  const [showVideoModal, setShowVideoModal] = useState(false);

  const { tier } = useAccessTier();
  const hasAccess = canViewSeries(tier);
  const [showPaywall, setShowPaywall] = useState(false);

  if (episodeId === null || mediaId === null) {
    return null;
  }

  return (
    <>
      <div
        style={{ width: '100%', height: '100%' }}
        onClick={() => {
          if (hasAccess) setShowVideoModal(true);
          else setShowPaywall(true);
        }}
      >
        {children}
      </div>
      <Modal
        open={showVideoModal}
        onClose={() => setShowVideoModal(false)}
        initialEpisode={episode}
      />
      {showPaywall && (
        <SeriesPaywall onClose={() => setShowPaywall(false)} returnUrl={episodeUrl} />
      )}
    </>
  );
};
